module.exports = __webpack_public_path__ + "static/img/hei.fea69e92.gif";